export const tabs = [
  { id: "overview", name: "Overview", icon: "📖" },
  { id: "problem1", name: "Problem 1", icon: "🔢" },
  { id: "problem2", name: "Problem 2", icon: "➗" },
  { id: "problem3", name: "Problem 3", icon: "📚" },
  { id: "problem4", name: "Problem 4", icon: "🔤" },
  { id: "alternate", name: "Alternate", icon: "🔄" },
  { id: "reference", name: "Quick Reference", icon: "📋" },
  { id: "tips", name: "Exam Tips", icon: "💡" },
];
